import axios from '../helpers/axios'
import { logError } from '../services';

export const createBulkStandardFeatures = async (post: { standardFeature: string, standardFeatureSelection: string; selectedNeighborhoods: any[], selectedPlanStyles: any[] }): Promise<any> => {
  try {
    const { data } = await axios.post(`/api/bulk-standard-features`, post);
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: post
      },
      'createBulkStandardFeatures failed'
    );
    return Promise.reject(error.response.data);
  }
};
